import React, { useMemo, useState } from 'react';
import { useQuery, gql } from '@apollo/client';
import { formatDateTime } from '../utils/formatDate';

const GET_HISTORIAL = gql`
  query GetHistorial($id: uuid!) {
    historial_acusados(where: { acusado_id: { _eq: $id } }, order_by: { fecha_cambio: desc }) {
      id
      estado_anterior
      estado_nuevo
      detalle_cambio
      fecha_cambio
      usuario_id
    }
  }
`;

export default function HistorialAcusadoModal({ acusado, onClose }) {
  const { data, loading } = useQuery(GET_HISTORIAL, {
    variables: { id: acusado.acusado_id },
    fetchPolicy: 'network-only',
    errorPolicy: 'all',
  });
  const [filtro, setFiltro] = useState('');

  const historial = useMemo(() => {
    const rows = data?.historial_acusados || [];
    return rows.map((h) => {
      const accion = h.estado_nuevo
        ? 'cambio_estado'
        : (h.detalle_cambio || '').toLowerCase().includes('testimonio')
          ? 'testimonio'
          : (h.detalle_cambio || '').toLowerCase().includes('audio')
            ? 'audio'
            : (h.detalle_cambio || '').toLowerCase().includes('documento')
              ? 'documento'
              : 'actualizacion';
      return {
        id: h.id,
        accion,
        detalle: h.detalle_cambio || 'Actualizacion registrada',
        usuario: h.usuario_id || 'sistema',
        fecha: h.fecha_cambio || new Date().toISOString(),
      };
    });
  }, [data]);

  return (
    <div className="modal show d-block" tabIndex="-1" role="dialog" style={{ background: 'rgba(0,0,0,0.3)' }}>
      <div className="modal-dialog modal-lg">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Historial del Acusado</h5>
            <button type="button" className="btn-close" onClick={onClose}></button>
          </div>
          <div className="modal-body">
            <div className="d-flex gap-2 mb-3">
              <select className="form-select w-auto" value={filtro} onChange={e => setFiltro(e.target.value)}>
                <option value="">Todas las acciones</option>
                <option value="creacion">Creación</option>
                <option value="cambio_estado">Cambio de estado</option>
                <option value="testimonio">Testimonio</option>
                <option value="audio">Audio</option>
                <option value="documento">Documento</option>
              </select>
              <button className="btn btn-outline-secondary" onClick={() => {
                const data = JSON.stringify((filtro ? historial.filter(h => h.accion === filtro) : historial), null, 2);
                const blob = new Blob([data], { type: 'application/json' });
                const url = URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url; a.download = `historial_${acusado.acusado_id}.json`; a.click();
                URL.revokeObjectURL(url);
              }}>Exportar JSON</button>
            </div>
            {loading ? (
              <div>Cargando...</div>
            ) : (filtro ? historial.filter(h => h.accion === filtro).length === 0 : historial.length === 0) ? (
              <div className="text-muted">Sin registros de historial.</div>
            ) : (
              <ul className="list-group">
                {(filtro ? historial.filter(h => h.accion === filtro) : historial).map(h => (
                  <li className="list-group-item d-flex justify-content-between align-items-start" key={h.id}>
                    <div>
                      <div className="fw-bold text-capitalize">{h.accion.replace('_', ' ')}</div>
                      <div className="small text-muted">{h.detalle}</div>
                      <div className="small">Por: {h.usuario}</div>
                    </div>
                    <span className="badge bg-secondary">{formatDateTime(h.fecha)}</span>
                  </li>
                ))}
              </ul>
            )}
          </div>
          <div className="modal-footer">
            <button className="btn btn-secondary" onClick={onClose}>Cerrar</button>
          </div>
        </div>
      </div>
    </div>
  );
}
